import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";

// OBTENER LISTA CORREOS
export const getListaCorreosPublic = async (IdListaCorreo, Token) => {
  const respuesta = await PublicInterceptor(`Base/IT/ListaCorreo/${IdListaCorreo}`, "GET", {}, Token);
  return respuesta;
};

export const sendEmailInscripcion = async(objeto, Token) =>{
  const result = await PublicInterceptor('Compras/Proveedores/email/token', 'POST', objeto, Token)
  return result
}

export const saveRegistroExonerado = async (Datos, Token) => {
  const result = await PublicInterceptor("Compras/Proveedores/saveRegistroExonerado", "POST", { Datos }, Token);
  return result;
};

export const getRegistrosExonerados = async (IdProveedor, Token) => {
  const result = await PublicInterceptor("Compras/Proveedores/getRegistrosExonerados", "POST", { IdProveedor }, Token
);
  return result;
};

export const getRegistrosExoneradosPrivado = async (IdProveedor) => {
  const result = await PrivateInterceptor(
    "Compras/Proveedores/getRegistrosExonerados", "POST", { IdProveedor }
  );
  return result;
};

export const RevisarRegistroExonerado = async (
  IdRegistro,
  IdUsuarioReviso,
  IdEstado = null
) => {
  const result = await PrivateInterceptor(
    "Compras/Proveedores/RevisarRegistroExonerado",
    "POST",
    {
      IdRegistro,
      IdUsuarioReviso,
      IdEstado,
    }
  );

  return result;
};

// OBTENER PROVEEDORES PARA SCREEN
export const getProveedor = async () => {
  const respuesta = await PrivateInterceptor(`Compras/Proveedores`, "GET");
  return respuesta;
};

export const getProveedorSinEliminar = async () => {
  const respuesta = await PrivateInterceptor(`Compras/Proveedores/SinEliminados`, "GET");
  return respuesta;
};

export const getProveedorAct = async () => {
  const respuesta = await PrivateInterceptor(`Compras/Proveedores/Activos`, "GET");
  return respuesta;
};

// AGREGAR O EDITAR PROVEEDORES PARA SCREEN
export const addProveedor = async (data) => {
  const respuesta = await PrivateInterceptor(`Compras/Proveedores/add`, "POST", data);
  return respuesta;
};

// OBTENER ENLACE DE INSCRIPCION DE UN PROVEEDOR
export const getEnlaceInscripcion = async (IdVendor, IdUser) => {
  const result = await PrivateInterceptor(`Compras/Proveedores/LinkInscripcion`, 'POST', {IdVendor, IdUser});
  return result;
}

export const getCompanyCustomer = async(IdVendor) =>{
  const result = await PrivateInterceptor(`Compras/Proveedores/${IdVendor}`, 'GET')
  return result
}

// GUARDAR INSCRIPTION DE PROVEEDOR
export const saveInscripcionProveedor = async (Company, token) => {
  const result = await PublicInterceptor(`Compras/Proveedores/InscripcionProveedor`, 'PUT', Company, token);
  return result;
}

// GUARDAR INSCRIPCION DE PROVEEDOR
export const GuardarInscripcion = async (Datos, token) => {
  const respuesta = PublicInterceptor("Compras/Proveedores/GuardarInscripcion", "POST",{Datos}, token);
  return respuesta;
};

// OBTENER ESTADOS DE REVISION DE PROVEEDOR
export const getEstadosRevisionProveedor = async (token) => {
  const result = await PublicInterceptor(
    "Compras/Proveedores/getEstadosRevisionProveedor",
    "GET",
    undefined,
    token
  );

  return result;
};
// OBTENER ESTADOS DE REVISION DE PROVEEDOR
export const RevisarFormularioCompras = async (Datos, token) => {
  const result = await PublicInterceptor(
    "Compras/Proveedores/RevisarFormularioCompras",
    "POST",
    Datos,
    token
  );

  return result;
};

// OBTIENER INFORMACION DE UN PROVEEDOR
export const getProveedorInfo = async(IdCustomer, token) => {
  const result = await PublicInterceptor(`Compras/Proveedores/getProveedor`, 'POST',IdCustomer, token )
  return result;
}

// OBTIENER INFORMACION DE UN PROVEEDOR
export const getProveedorInfoPorId = async(IdVendor, token) => {
  const result = await PublicInterceptor(`Compras/Proveedores/getProveedorPorId`, 'POST',{IdVendor}, token )
  return result;
}

// ACTUALIZAR ESTADO DE EDICION DEL ENLACE DE INSCRIPCION DEL PROVEEDOR 
export const updateEnlaceInscripcion = async (body) => {
  const result = await PrivateInterceptor(`Compras/Proveedores/actualizarEstadoEdicion`, 'PUT', body);
  return result;
}

// ACTUALIZAR ESTADO DE LOS PROVEEDORES
export const postChangeEstados = async (data) => {
  const result = await PrivateInterceptor(`Compras/Proveedores/postChangeEstados`, 'POST', data);
  return result;
}

// ACTUALIZAR ESTADO DE REVISION DEL PROVEEDOR
export const postChangeEstadoRevision = async (data) => {
  const result = await PrivateInterceptor(
    `Compras/Proveedores/postChangeEstadoRevision`,
    "POST",
    data
  );

  return result;
};

 // ACTUALIZAR ESTADO DE REVISION DEL PROVEEDOR
export const postSolicitudEdicionProveedor = async (data) => {
  const result = await PrivateInterceptor(
    `Compras/Proveedores/SolicitudEdicionProveedor`,
    "POST",
    data
  );

  return result;
};

// OBTENER SOLICITUDES DE EDICION DE PROVEEDORES
export const getAllSolicitudesEdicion = async (FechaInicio, FechaFinal) => {
  const result = await PrivateInterceptor(
    "Compras/Proveedores/getAllSolicitudesEdicion",
    "POST",
    {
      FechaInicio,
      FechaFinal,
    }
  );

  return result;
};

// OBTENER SOLICITUD DE EDICION DE PROVEEDOR POR ID
export const getSolicitudEdicionId = async (IdSolicitudEdicion) => {
  const result = await PrivateInterceptor(
    "Compras/Proveedores/getSolicitudEdicionId",
    "POST",
    {
      IdSolicitudEdicion,
    }
  );

  return result;
};

// ACTUALIZAR SOLICITUD DE EDICION DE PROVEEDOR
export const UpdSolicitudesEdicion = async (data) => {
  const result = await PrivateInterceptor(
    "Compras/Proveedores/UpdSolicitudesEdicion",
    "POST",
    data
  );

  return result;
};

// ENVIAR CORREO DE SOLICITUD DE EDICION DE PROVEEDOR
export const sendEmailSolicitudEdicionProveedor = async (data) => {
  const result = await PrivateInterceptor(
    `Compras/Proveedores/email/token`,
    "POST",
    data
  );

  return result;
};

// GET ARCHIVOS DE PROVEEDOR
export const getArchivoProveedor = async (file, IdCustomer, token = localStorage.getItem('ppfToken')) => {
  const result = await PublicInterceptor(`Compras/Proveedores/${file}/${IdCustomer}`, 'GET', undefined, token);
  return result;
}

// GUARDAR ARCHIVO FORMATO INSCRIPCION
export const saveArchivoFormatoInscripcion = async (FormatoInscripcion, IdCustomer, FormatoInscripcionName, token ) => {
  const result = await PublicInterceptor(`Compras/Proveedores/FormatoInscripcion/${IdCustomer}`, 'PUT', {FormatoInscripcion, FormatoInscripcionName}, token);
  return result;
}

// OBTENER ARCHIVO FORMATO INSCRIPCION
export const getArchivoFormatoInscripcion = async (IdCustomer, token = localStorage.getItem('ppfToken')) => {
  const result = await PublicInterceptor(`Compras/Proveedores/FormatoInscripcion/${IdCustomer}`, 'GET', undefined, token);
  return result;
}

// GUARDAR FILE BIC
export const saveArchivoBIC = async (BIC, IdCustomer, BICName, token ) => {
  const result = await PublicInterceptor(`Compras/Proveedores/FileBIC/${IdCustomer}`, 'PUT', {FileBIC: BIC, BICName: BICName}, token);
  return result;
}

// GUARDAR FILE CONSTANCIA DE PAGOS A CUENTA
export const saveArchivoConstanciaPagos = async (ConstanciaPagos, IdCustomer, ConstanciaPagosName, token ) => {
  const result = await PublicInterceptor(`Compras/Proveedores/FileConstanciaPagos/${IdCustomer}`, 'PUT', {FileConstPagosCuenta: ConstanciaPagos, ConstPagosName: ConstanciaPagosName}, token);
  return result;
}

// GUARDAR FILE ESCRITURA DE CONSTITUCION
export const saveArchivoEscrituraConstitucion = async (EscrituraConstitucion, IdCustomer, EscrituraConstitucionName, token ) => {
  const result = await PublicInterceptor(`Compras/Proveedores/FileEscrituraConstitucion/${IdCustomer}`, 'PUT', {FileEscrituraConstitucion: EscrituraConstitucion, EscrituraConstitucionName: EscrituraConstitucionName}, token);
  return result;
}

// GUARDAR FILE PERMISO DE OPERACIONES
export const saveArchivoPermisoOperaciones = async (PermisoOperaciones, IdCustomer, PermisoOperacionesName, token ) => {
  const result = await PublicInterceptor(`Compras/Proveedores/FilePermisoOperaciones/${IdCustomer}`, 'PUT', {FilePermisoOperaciones: PermisoOperaciones, PermisoOperacionesName: PermisoOperacionesName}, token);
  return result;
}

// GUARDAR FILE REGISTRO DEXONERADO
export const saveArchivoRegistroDexonera = async (RegistroDexonera, IdCustomer, RegistroDexoneraName, token ) => {
  const result = await PublicInterceptor(`Compras/Proveedores/FileRegistroExonerado/${IdCustomer}`, 'PUT', {FileRegistroExonerado: RegistroDexonera, RegistroExoneradoName: RegistroDexoneraName}, token);
  return result;
}

// GUARDAR FILE REGISTRO DEXONERADO
export const saveArchivoFactura = async (Factura, IdCustomer, FacturaName, token ) => {
  const result = await PublicInterceptor(`Compras/Proveedores/FileFactura/${IdCustomer}`, 'PUT', {FileFactura: Factura, FacturaName: FacturaName}, token);
  return result;
}

// --------------------------------------------------------------------------------------------------------------------------------------
export const getArchivosBIC = async(Codigo, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/BIC/getTest/` + Codigo, 'GET', {}, Token)
  return respuesta;
}

export const getArchivosFactura = async(Codigo, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Factura/getTest/` + Codigo, 'GET', {}, Token)
  return respuesta;
}
export const getArchivosPermiso = async(Codigo, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Permiso/getTest/` + Codigo, 'GET', {}, Token)
  return respuesta;
}
export const getArchivosEscritura = async(Codigo, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Escritura/getTest/` + Codigo, 'GET', {}, Token)
  return respuesta;
}
export const getArchivosConstancia = async(Codigo, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Constancia/getTest/` + Codigo, 'GET', {}, Token)
  return respuesta;
}
export const getArchivosRegistro = async(Codigo, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Registro/getTest/` + Codigo, 'GET', {}, Token)
  return respuesta;
}
export const getArchivosFormato = async(Codigo, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Formato/getTest/` + Codigo, 'GET', {}, Token)
  return respuesta;
}

// ----------------------------------------------------------------------------------------------------------------------------------------------------
export const descargarArchivoBIC = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/BIC/getFile/${Codigo}/${nombre}`, 'GET', {} , Token)
  return respuesta;
}

export const descargarArchivoFactura = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Factura/getFile/${Codigo}/${nombre}`, 'GET', {} , Token)
  return respuesta;
}

export const descargarArchivoPermiso = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Permiso/getFile/${Codigo}/${nombre}`, 'GET', {} , Token)
  return respuesta;
}

export const descargarArchivoEscritura = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Escritura/getFile/${Codigo}/${nombre}`, 'GET', {} , Token)
  return respuesta;
}

export const descargarArchivoConstancia = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Constancia/getFile/${Codigo}/${nombre}`, 'GET', {} , Token)
  return respuesta;
}

export const descargarArchivoRegistro = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Registro/getFile/${Codigo}/${nombre}`, 'GET', {} , Token)
  return respuesta;
}

export const descargarArchivoFormato = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Formato/getFile/${Codigo}/${nombre}`, 'GET', {} , Token)
  return respuesta;
}

//---------------------------------------------------------------------------------------------------------------------------------------
export const eliminarArchivoBIC = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/BIC/deleteFile/${Codigo}/${nombre}`, 'DELETE', {} , Token)
  return respuesta;
}

export const eliminarArchivoFactura = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Factura/deleteFile/${Codigo}/${nombre}`, 'DELETE', {} , Token)
  return respuesta;
}

export const eliminarArchivoPermiso = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Permiso/deleteFile/${Codigo}/${nombre}`, 'DELETE', {} , Token)
  return respuesta;
}

export const eliminarArchivoEscritura = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Escritura/deleteFile/${Codigo}/${nombre}`, 'DELETE', {} , Token)
  return respuesta;
}

export const eliminarArchivoConstancia = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Constancia/deleteFile/${Codigo}/${nombre}`, 'DELETE', {} , Token)
  return respuesta;
}

export const eliminarArchivoRegistro = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Registro/deleteFile/${Codigo}/${nombre}`, 'DELETE', {} , Token)
  return respuesta;
}

export const eliminarArchivoFormato = async (Codigo, nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Proveedores/Formato/deleteFile/${Codigo}/${nombre}`, 'DELETE', {} , Token)
  return respuesta;
}